<template>
    <div>
        <!--edit-->
        <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">{{ TipoDocumento.tpdId ? 'Alterar tipo de documento' : 'Novo tipo de documento' }}</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Cadastro de tipos de
                                documentos</a> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><span>{{ TipoDocumento.tpdId ? 'Alterar' : 'Novo cadastro' }}</span></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="gp-admin-form-header">
                                <span><v-icon size="20">mdi-file-cog-outline</v-icon></span>
                                <div>
                                    <h4>{{ TipoDocumento.tpdId ? 'Alterar tipo de documento' : 'Novo tipo de documento' }}</h4>
                                    <p>Preencha os dados e defina a disponibilidade deste cadastro.</p>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-2 col-lg-2" v-show="false">
                                        <div class="form-group">
                                            <label>Identificador</label>
                                            <input v-model="TipoDocumento.tpdId" type="text" class="form-control"
                                                placeholder="Id" />
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label>Nome</label>
                                            <input v-model="TipoDocumento.tpdNome" :rules="nameRules" :counter="100"
                                                type="text" class="form-control" placeholder="Nome" />
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label>Visivel</label>
                                            <select v-model="TipoDocumento.tpdVisivel" class="form-select form-control"
                                                id="defaultSelect">
                                                <option value="">Selecione</option>
                                                <option :value=true>Sim</option>
                                                <option :value=false>Não</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label>Ativo</label>
                                            <select v-model="TipoDocumento.tpdAtivo" class="form-select form-control">
                                                <option value="">Selecione</option>
                                                <option :value=true>Sim</option>
                                                <option :value=false>Não</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-action gp-admin-actions gp-detail-actions">
                        <button v-if="TipoDocumento.tpdId != 0" type="button" class="btn btn-success"
                            style="color:#ffffff;" @click="Put()">
                            Alterar
                        </button>
                        <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="Add()">
                            Salvar
                        </button>
                        <a href="#" @click="EditCancel()" class="btn btn-link">Cancelar</a>
                    </div>
                </div>
            </div>
        </div>
        <!--Grid-->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Cadastro de tipos de documentos</h4>
                                    <a href="#" @click="EditNew()" class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body">
                                <adm-data-table :headers="headers" :items="TipoDocumentos" v-model="itemsSelected" alternating
                                    theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina">
                                    <template #item-tpdVisivel="item">
                                        <span>{{ item.tpdVisivel ? 'Sim' : 'Não' }}</span>
                                    </template>
                                    <template #item-tpdAtivo="item">
                                        <span>{{ item.tpdAtivo ? 'Sim' : 'Não' }}</span>
                                    </template>
<template #item-actions="item">
    <div class="gp-table-actions">
        <button type="button" class="gp-table-action gp-action-edit" title="Editar" @click="EditGrid(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button>
        <button v-show="false" type="button" class="gp-table-action gp-action-delete" title="Excluir" @click="DeleteGrid(item)"><v-icon size="17">mdi-trash-can-outline</v-icon></button>
    </div>
</template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
export default {
    name: 'CadastroTipoDocumentoView',
    components: {
        EasyDataTable
    },
    data: () => ({
        EditView: false,
        TipoDocumento: {
            tpdId: 0,
            tpdNome: '',
            tpdVisivel: '',
            tpdAtivo: '',
        },
        TipoDocumentos: [],
        selectedVisivel: null,
        headers: [
            { text: "Id", value: "tpdId", sortable: true, },
            { text: "Nome", value: "tpdNome", sortable: true, },
            { text: "Visivel", value: "tpdVisivel", sortable: true, },
            { text: "Ativo", value: "tpdAtivo", sortable: true, },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
    }),
    methods: {
         //edit
         EditNew(){
            this.EditView = true;
            this.TipoDocumento.tpdId = 0;
            this.TipoDocumento.tpdNome= '';
            this.TipoDocumento.tpdVisivel= '';
            this.TipoDocumento.tpdAtivo= '';
        },
        EditCancel(){
            //window.location.reload();
            this.$router.go(0);
        },
        Add() {
            if (this.TipoDocumento.tpdNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.TipoDocumento.tpdVisivel === '') {
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.TipoDocumento.tpdAtivo === '') {
                this.$mensagemAviso("Ativo Obrigatório.")
            }
            else {
                axios.post(`/Telas/TipoDocumento/Add`, this.TipoDocumento)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                        }
                    });
            }
        },
        Put() {
            if (this.TipoDocumento.tpdNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.TipoDocumento.tpdVisivel === '') {
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.TipoDocumento.tpdAtivo === '') {
                this.$mensagemAviso("Ativo Obrigatório.")
            }
            else {
                axios.put(`/Telas/TipoDocumento/Update`, this.TipoDocumento)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                        }
                    });
            }
        },
        //edit
        EditGrid(item) {
            this.EditView = true;
            if (item.tpdId != ''){
            axios.get(`/Telas/TipoDocumento/GetById/` + item.tpdId)
                .then(response => {
                    this.TipoDocumento = response.data;
                });
            }
        },
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.tpdId;
                axios.delete(`/Telas/TipoDocumento/Delete/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                        this.Get();
                    }
                });
            }
            });
        },
        Get() {
            this.EditView = false;
            axios.get(`/Telas/TipoDocumento/GetAll`)
                .then(response => {
                    this.TipoDocumentos = response.data;
                });
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style></style>
